// Listino a posti lato client — identico a backend/pricing.py.
// Serve solo per anteprime/totali istantanei; l'ordine è ricalcolato dal server.
export function seatSubtotal(price, seats) {
  let total = 0;
  for (let n = 1; n <= Math.max(1, seats); n++) {
    const unit = n === 1 ? price : n === 2 ? Math.round(price * 90) / 100 : Math.round(price * 80) / 100;
    total = Math.round((total + unit) * 100) / 100;
  }
  return total;
}

export const eur = (v) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(v || 0));
